export class CookiesOptionsData {
    SoundOn: boolean = true;
    ChatVisible: boolean = true;
    ActiveLanguage: string = '';
}
